/**
 * Constants for Foundation settings tab
 */

import type { POVPreset } from './types'

// POV Presets with cinematography metaphor
export const POV_PRESETS: POVPreset[] = [
  {
    id: 'third_person',
    label: 'Third Person Narrative',
    tags: {
      shotType: 'Wide Shot',
      intimacyLevel: 'Least Intimate',
      interactionMode: 'Observer/Storyteller',
    },
    description:
      'The narrator observes from a distance, telling a story about other people. Creates emotional distance and objective perspective.',
    example: 'He loved her, but she never returned his love',
  },
  {
    id: 'first_person',
    label: 'First Person Story',
    tags: {
      shotType: 'Medium Shot',
      intimacyLevel: 'Personal Story',
      interactionMode: 'Singer as Participant',
    },
    description:
      'The singer shares their own experience and feelings. Personal but still telling a story to the audience.',
    example: 'I loved her so much, but she never returned my love',
  },
  {
    id: 'second_person',
    label: 'Second Person Reflection',
    tags: {
      shotType: 'Closer Shot',
      intimacyLevel: 'Intimate but Unfulfilled',
      interactionMode: 'You and He/She',
    },
    description:
      'The singer addresses "you" while discussing someone else ("he"/"she"). Creates intimacy with the listener while maintaining narrative distance from the subject.',
    example: 'You loved her so much, yet she did not return your love',
  },
  {
    id: 'direct_address',
    label: 'Direct Address',
    tags: {
      shotType: 'Closest Shot',
      intimacyLevel: 'Most Intimate',
      interactionMode: 'Direct Connection',
    },
    description:
      'The singer speaks directly to "you" about "you". Creates the most intimate connection, as if having a one-on-one conversation.',
    example: 'I loved you so much, but you never returned my love',
  },
]

// Tag color mappings for intimacy progression
export const INTIMACY_COLORS = {
  'Least Intimate': 'bg-purple-500/20 text-purple-300 border-purple-400/30',
  'Personal Story': 'bg-blue-500/20 text-blue-300 border-blue-400/30',
  'Intimate but Unfulfilled': 'bg-indigo-500/20 text-indigo-300 border-indigo-400/30',
  'Most Intimate': 'bg-pink-500/20 text-pink-300 border-pink-400/30',
}

// Default tag colors for shot type and interaction mode
export const DEFAULT_TAG_COLOR = 'bg-gray-500/20 text-gray-300 border-gray-400/30'
